// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-detail[data-v-fa26a48c]{background-color:#fff;color:#000;padding:10px}", ""]);
// Exports
module.exports = exports;
